module.exports = __webpack_public_path__ + "89a4e6ab6ede8064281275386105d5f4.obj";